module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s8-d40aa388c6c9608e9176abccf44ecbd9.jpg";